import React from 'react';
import { NavLink } from 'react-router-dom';
import './HomeAbout.css'
import '../../Style/ResponsiveBreakpoint.css'

const HomeAboutNavbar = () => {
    return (
        <nav class="navbar navbar-expand-lg navbar-light home-about-navbar">
            <button class="navbar-toggler " type="button" data-bs-toggle="collapse" data-bs-target="#navbarNav" aria-controls="navbarNav" aria-expanded="false" aria-label="Toggle navigation">
                <span class="navbar-toggler-icon"></span>
            </button>
            <ul class="collapse navbar-collapse navbar-nav nav-pills nav-fill text-uppercase" id="navbarNav">
                <li class="nav-item">
                    <NavLink
                        to="/"
                        className={({ isActive }) =>
                            isActive ? 'aboutActiveLink' : undefined
                        }
                    >About</NavLink>
                </li>
                <li class="nav-item">
                    <NavLink
                        to="homeAboutSkill"
                        className={({ isActive }) =>
                            isActive ? 'aboutActiveLink' : undefined
                        }
                    >Skill</NavLink>
                </li>
                <li class="nav-item">
                    <NavLink to="homeAboutService"
                        className={({ isActive }) =>
                            isActive ? 'aboutActiveLink' : undefined
                        }
                    >Service</NavLink>
                </li>
                <li class="nav-item">
                    <NavLink to="homeAboutInterview"
                        className={({ isActive }) =>
                            isActive ? 'aboutActiveLink' : undefined
                        }
                    >Interview</NavLink>
                </li>
                <li class="nav-item">
                    <NavLink
                        to="homeAboutAward"
                        className={({ isActive }) =>
                            isActive ? 'aboutActiveLink' : undefined
                        }
                    >Award</NavLink>
                </li>
            </ul>

        </nav>
    );
};

export default HomeAboutNavbar;